import Udesk from 'Udesk';
import React from 'react';
import { LoginStatusCode } from './const';
import { Modal } from 'udesk-ui';
import UdeskLocales from 'UdeskLocales';

export default class LoginComponent extends React.Component {
    //#region state
    state = {
        email: null,
        password: null,
        rememberMe: false,
        errorMsg: '',
        loading: false,
    };
    privates = {
        formInstance: React.createRef(),
        isIpForbidden: false,
        relationCompanyList: undefined,
        virtualLoginModal: false,
        verifyModalVisible: false,
        langCode: 'zh',
        loginParams: {},
        companyId: undefined,
    };
    //#endregion

    //#region Life Cycle
    componentDidMount() {}
    componentWillUnmount() {}
    //#endregion

    //#region actions
    actions = {
        onAfterClose() {
            this.privates.isIpForbidden = false;
            this.actions.update();
        },
        onValueChanged(obj, key, e) {
            let value = e;
            if (key === 'rememberMe') {
                value = e.target.checked;
            } else if (e.target) {
                value = e.target.value;
            }
            obj[key] = value;
            this.actions.update();
        },
        loginV2(values) {
            this.setState({
                errorMsg: undefined,
            });

            const { email, password, mobile, verificationCode } = values;

            if (!email) {
                this.setState({
                    errorMsg: this.locales.pages.auth.login.emailCannotBeEmpty,
                });
                return false;
            }

            if (!password) {
                this.setState({
                    errorMsg: this.locales.pages.auth.login.passwordCannotByEmpty,
                });
                return false;
            }

            const data = {
                email,
                password,
                mobile,
                verificationCode,
            };

            this.setState({
                loading: true,
            });

            Udesk.ajax
                .post(Udesk.business.apiPath.concatApiPath('/login', this.props.sdkOptions), data)
                .then(
                    (resp) => {
                        if (resp.code === Udesk.system.apiCodes.mustChangePassword) {
                            // TODO 目前还没实现修改密码页面，暂时给一个提示信息
                            this.setState({
                                errorMsg: this.locales.pages.auth.login.mustChangeLogin,
                            });
                        } else if (resp.code === Udesk.system.apiCodes.disableStatus) {
                            this.setState({
                                errorMsg: this.locales.pages.auth.login.forbiddenLogin,
                            });
                        } else if (resp.code === Udesk.system.apiCodes.dimissionStatus) {
                            this.setState({
                                errorMsg: this.locales.pages.auth.login.dismissionLogin,
                            });
                        } else {
                            if (resp.data?.loginStatusCode === LoginStatusCode.Multi) {
                                this.privates.relationCompanyList =
                                    resp.data.relationCompanyList || [];
                                this.privates.virtualLoginModal = true;
                                this.actions.update();
                            } else if (resp.data?.loginStatusCode === LoginStatusCode.Verify) {
                                this.privates.loginParams = {
                                    ...data,
                                    mobile: resp.data.mobile,
                                };
                                this.privates.companyId = resp.data.companyId;
                                this.privates.langCode = resp.data.userLanguage || 'zh';
                                this.privates.verifyModalVisible = true;
                                this.actions.update();
                            } else if (resp.data?.loginStatusCode === LoginStatusCode.VerifyFail) {
                                Modal.error({
                                    title: /* 无法登录！ */ UdeskLocales['current'].pages.login
                                        .component.unableToLogIn,
                                    content:
                                        /* 该账号未设置正确电话信息，无法获取验证码，请联系管理员填写正确电话信息后重试。 */ this
                                            .locales.pages.login.component
                                            .theAccountDoesNotHaveTheCorrectPhoneInformationAndCannotObtainTheVerificationCodePleaseContactTheAdministratorToFillInTheCorrectPhoneInformationAndTryAgain,
                                });
                            } else {
                                let refer = this.privates.model.refer;
                                let userName = window.localStorage.getItem('userName');
                                if (refer && userName === email) {
                                    window.location.href = refer;
                                } else {
                                    window.location.href = '/entry-page';
                                }
                            }
                        }
                        this.setState({
                            loading: false,
                        });
                    },
                    (reason) => {
                        // this.privates.isIpForbidden = true;

                        let errorMsg = reason.errorMsg || this.locales.pages.auth.login.loginError;
                        this.setState({
                            loading: false,
                            errorMsg: errorMsg,
                        });

                        // Udesk.ui.notify.error(errorMsg);
                    }
                );
        },
        onVirtualLoginModalClose() {
            this.privates.virtualLoginModal = false;
            this.actions.update();
        },
        onVerifyLogin(verificationCode) {
            this.actions.loginV2({ ...this.privates.loginParams, verificationCode });
        },
        onVerifyModalClose() {
            this.privates.verifyModalVisible = false;
            this.setState({
                errorMsg: undefined,
            });
            this.actions.update();
        },
    };
    //#endregion
}
